<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in links">
        <div v-if="link.url === null" :key="key" class="mb-1 mr-1 px-4 py-3 text-gray-400 text-sm leading-4 border rounded" v-html="link.label" />
        <Link v-else :key="`link-${key}`" class="mb-1 mr-1 px-4 py-3 focus:text-indigo-500 text-sm leading-4 hover:bg-white border focus:border-indigo-500 rounded" :class="{ 'bg-white': link.active }" :href="getHref(link)" v-html="link.label" />
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Link,
  },
  props: {
    links: Array,
  },
  methods: {
    getHref(link) {
      if (!link.url) return null;

      const currentUrl = new URL(this.$page.url, window.location.origin);
      const linkUrl = new URL(link.url, window.location.origin);

      // Preserve all current search params except page
      const searchParams = new URLSearchParams(currentUrl.search);

      // Set the page from the link
      const page = linkUrl.searchParams.get('page');
      if (page) {
        searchParams.set('page', page);
      } else {
        searchParams.delete('page');
      }

      return currentUrl.pathname + '?' + searchParams.toString();
    }
  }
}
</script>
